module.exports = __webpack_public_path__ + "img/program-kigurumix.0f86da52.jpg";